module.exports = __webpack_public_path__ + "img/overview_shop.067a90ed.jpg";